import { type Exercise } from './Exercise';
import { type Video } from './Video';
import { type Challenge } from '../../playable/models/Challenge';

// export const AvailableSkillModelLevels = [1, 2, 3, 4]
export const AvailableSkillModelLevels = [1, 2];

export type SkillStatus = 'Validated' | 'InProgress' | 'NotDiscovered' | 'Blocked';
export const SkilStatusOrder: Record<SkillStatus, number> = {
  Validated: 3,
  InProgress: 1,
  NotDiscovered: 2,
  Blocked: 4,
}
export const SkillStatusIcons: Record<SkillStatus, string> = {
  Validated: 'mdi-check-circle-outline',
  InProgress: 'mdi-play-circle-outline',
  NotDiscovered: 'mdi-circle-outline',
  Blocked: 'mdi-lock-outline',
}
export const SkillStatusColors: Record<SkillStatus, string> = {
  Validated: 'green',
  InProgress: 'primary',
  NotDiscovered: 'grey-5',
  Blocked: 'grey-5',
}
export const SkillStatusLabels: Record<SkillStatus, string> = {
  Validated: 'Validé',
  InProgress: 'En cours',
  NotDiscovered: 'Non découvert',
  Blocked: 'Inaccessible',
}
type SkillValidationType = 'NumberOfInstances' | 'NumberOfExercises';

export interface SkillModelProgression {
  id: number,
  name: string,
  description: string,
  status: SkillStatus,
  validation_value: number,
  completion: number,
}

export interface SkillCategory extends SkillModelProgression {
  difficulty: number;
  videos: Video[];
}

export interface Skill extends SkillModelProgression {
  image: string | null;
  difficulty: string;
  validation_type: SkillValidationType;
  prerequisites: {
    required_id: string;
    required_type: 'skill' | 'handprint-skill' | 'handprint' | 'rhytmic';
    status: Exclude<SkillStatus, 'Blocked'>;
  }[];
  exercise_count: number;
  version_count: number;
  challenge_count: number;
  videos: Video[];
  suggested_exercise?: Exercise
  skill_category_id: number;
}

export interface SkillUpdate extends SkillModelProgression {
  difficulty: number;
  validation_type: SkillValidationType;
  before_status: SkillStatus;
  before_completion: number | null;
}

export interface CompleteResponseData {
  skill_updates: SkillUpdate[];
  exercises_suggestions: {
    same_skill: Skill[];
    prerequisite: Skill[];
    new_skill: Skill[];
  };
  challenges_suggestions: Challenge[];
}

export interface ProgressSegments {
  percentage: number;
  class: 'segment-validated' | 'segment-discovered' | 'segment-not-discovered';
}
